import { render, staticRenderFns } from "./MenuSidebar.vue?vue&type=template&id=7ccda41e&scoped=true&"
import script from "./MenuSidebar.vue?vue&type=script&lang=js&"
export * from "./MenuSidebar.vue?vue&type=script&lang=js&"
import style0 from "@/styles/views/MenuSidebar/MenuSidebar.less?vue&type=style&index=0&id=7ccda41e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccda41e",
  null
  
)

export default component.exports